import { MessageFileTypeEnum } from '@avanta/shared/constants/chat';
import { type OptimisticMessage, type MessageReaction } from '@avanta/shared/types/chat';
import { AudioMessage } from '../AudioMessage';
import { FileMessage, ImageMessage, VideoMessage } from '../MediaMessages';

export const MessageFileType = {
  [MessageFileTypeEnum.IMAGE]: ImageMessage,
  [MessageFileTypeEnum.VIDEO]: VideoMessage,
  [MessageFileTypeEnum.AUDIO]: AudioMessage,
  [MessageFileTypeEnum.FILE]: FileMessage,
};
export interface ContentProps {
  message: OptimisticMessage;
  isEditing?: boolean;
  reactions?: MessageReaction;
  onReaction?: (reactions: MessageReaction) => void;
}
